import React, { useState, useEffect } from 'react'
import Styles from './source.module.css'
import { Image } from '@chakra-ui/react'

const Target = (props) => {
  const [imageSrc, setImageSrc] = useState('')
  
  useEffect(() => {
    const loadImage = async () => {
      if (props.title) {
        try {
          // Dynamically import the image based on props.title
          const imageModule = await import(`../../../../../assets/connectorImages/${props.title.toLowerCase()}.png`)
          setImageSrc(imageModule.default)
        } catch (error) {
          console.warn(`Image not found for ${props.title}:`, error)
          setImageSrc('') // Set empty string if image not found
        }
      }
    }
    loadImage()
  }, [props.title])
  
  return (
    <div className="card no-border no-boxshadow pb-0 mb-0 attatchicon">
        <div className="card-body">
            <div className={`connector-logo-container ${Styles.rightImageContainer}`}>
              {imageSrc && <Image src={imageSrc} alt={props.title} className={Styles.rightImage} />}
              {/* <img src={props.image} className="rightimage" title={""} /> */}
            </div>
            <h5 className="text-truncate add-connector-title"> {props.title} </h5>
        </div>
    </div>
  )
}

export default Target